import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { InfoWraper, LogoutButton } from './style';
import { logOut } from '../../../redux/authentication/actionCreator';
import FullScreen from './FullScreen';
import Language from './Language';

function AuthInfo({darkMode}) {

    const dispatch = useDispatch();
    const history = useNavigate();

    const SignOut = e => {
        e.preventDefault();
        dispatch(logOut());
        setTimeout(() => {
            history('/login', { replace: true });
        }, 100);
    };

    const userDetails = useSelector((state) => state.auth.loginData);
    useEffect(() => {
        if (!userDetails.name) {
            dispatch(logOut());
        }
        // eslint-disable-next-line
    }, [userDetails])


    
    return (
        <InfoWraper darkMode={darkMode}>
            <Language />
            <FullScreen />
            {/* <ThemeStyle /> */}
            <div className="nav-author">
                {/* <Popover placement="bottomRight" content={userContent} action="click">
                    <Link to="#" style={{}}>
                        <Avatar src={require(`../../../static/img/logo-icon.png`)} alt="admin user" />
                        </Link>
                        </Popover> */}
                    <span className='user-first__name'>{userDetails?.name ? userDetails.name.toUpperCase() : ''}</span>
                <LogoutButton onClick={SignOut} darkMode={darkMode} >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 12H14.88" stroke={(darkMode ? 'Red' :  'white')} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12.6504 8.65039L16.0004 12.0004L12.6504 15.3504" stroke={(darkMode ? 'Red' :  'white')} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M21.5002 13V15.26C21.5002 19.73 22.5001 21.52 15.2402 21.52H15.1102C8.00012 21.52 9.24016 20.07 8.91016 16.53" stroke={(darkMode ? 'Red' :  'white')} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.90039 7.56023C9.21039 3.96023 8.00037 2.49023 15.1104 2.49023H15.2404C22.0004 2.49023 21.5004 4.28023 21.5004 8.75023" stroke={(darkMode ? 'Red' :  'white')} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </LogoutButton>
            </div>
        </InfoWraper >
    );
}

export default AuthInfo;
